//#region src/media/webMediaAdapter.ts
var e = {
	createPreviewUrl(e) {
		return URL.createObjectURL(e);
	},
	revokePreviewUrl(e) {
		URL.revokeObjectURL(e);
	}
};
//#endregion
export { e as webMediaAdapter };
